import { helpers } from 'vuelidate';
import { cpf, cnpj } from "cpf-cnpj-validator";
import dayjs from "dayjs";
import DOMPurify from "dompurify";
// import customParseFormat from "dayjs/plugin/customParseFormat";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";
// dayjs.extend(customParseFormat);
dayjs.extend(isSameOrBefore);

const cepRegex = /^(\d{5}-?\d{3}|)$/;
// const wordCountMore2 = /^([a-zA-Z]+\s?\b){2,}$/;
// const wordCountMore2 = /((\w{2,}) (\w{2,}))/;

/**
 * Checks if given CPF is valid or not.
 * @param {string} value CNPJ
 * @returns CPF validity.
 */
export const cpfValid = (value) => cpf.isValid(value);

/**
 * Checks if given CNPJ is valid or not.
 * @param {string} value CNPJ
 * @returns CNPJ validity.
 */
export const cnpjValid = (value) => cnpj.isValid(value);

/**
 * Checks if given CPF or CNPJ is valid or not.
 * @param {string} value CPF or CNPJ
 * @returns CPF or CNPJ validity.
 */
export const cpfCnpjValid = (value) =>
  cpf.isValid(value) || cnpj.isValid(value);

/**
 * Checks if given date is after or the same as today.
 * @param {Date} value date to compare
 * @returns If the date is after or same as today.
 */
export const dateAfterToday = (value) => {
  if (!value) return true;
  if (typeof value === "string") return false;
  const date = dayjs(value);
  return date.isSameOrBefore(dayjs()) && date.isValid();
};

/**
 * Checks if cep is valid
 * @param {*} cep cep
 * @returns cep is valid or not
 */
export const cepValid = (cep) => cepRegex.test(cep);


// export const moreThan2Words = str => str.trim().split(" ").length >= 2;

/**
 * Check for Name input
 * @param {*} str name
 * @returns string and more than 2 words and more than 2 words with 2 characters 
 */
export const moreThan2Words = str => {
  const words = str.trim().split(" ");
  let wordsWithMore2Char = 0;
  words.map(x => {
    if (x.length >= 2) {
      wordsWithMore2Char++;
    }
  })

  return words.length >= 2 && wordsWithMore2Char >= 2;
};


export const inputClean = str => {
  if (!str) return true;

  const clean = DOMPurify.sanitize(str, { ALLOWED_TAGS: [] });

  return str === clean;
}

export const dateAfterTodayFrom = (dateFrom) =>
  helpers.withParams({ type: "dateAfterTodayFrom", value: dateFrom }, (date) => {
    if (!date) return true;
    const dateValue = dayjs(date);
    const dateFromValue = dayjs(dateFrom);
    if (!dateValue.isValid() || !dateFromValue.isValid()) return false;
    const result = dateFromValue.isSameOrBefore(dateValue); // && dateValue.isValid() && dateFromValue.isValid()
    return result;
  });